// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2bso-","footer":"Form_footer__3RzvS"};